module.exports = __webpack_public_path__ + "static/media/medicine.62a3167a.png";